export const BAR_MIN_HEIGHT = 160

// The visual viewport shrinks when a phone keyboard opens; innerHeight doesn't.
export const getBarMaxHeight = (): number => {
	if (typeof window === "undefined") return 400
	const viewportHeight = window.visualViewport?.height ?? window.innerHeight
	return Math.max(BAR_MIN_HEIGHT, Math.round(viewportHeight / 2))
}

/** The bar extends upward, so dragging up (a smaller clientY) grows it. */
export const draggedBarHeight = ({
	startHeight,
	startY,
	clientY,
	maxHeight,
}: {
	startHeight: number
	startY: number
	clientY: number
	maxHeight: number
}): number =>
	Math.min(maxHeight, Math.max(BAR_MIN_HEIGHT, startHeight + startY - clientY))
